import Navigator from 'app';
import SearchItemModel from './bill_search_item_model';
const SearchCollection = Backbone.Collection.extend({
  model: SearchItemModel,
  initialize: function (params) {
    this.url = 'https://www.documentcloud.org/api/search.json?mentions=10&per_page=1000&data=true&q=projectid%3A18221+current%3Atrue+' + params;
  },
  parse: function (response) {
    var data = response;
    if (response.documents) {
      data = response.documents;
    }
    return data;
  }
});
var API = {
  getSearchResults: function (params) {
    var defer = $.Deferred();
    var results = new SearchCollection(params);
    results.fetch({
      dataType: "jsonp",
      success: function (data) {
        defer.resolve(data);
      }
    });
    return defer.promise();
  }
};
Navigator.reqres.setHandler("bill:search", function (params) {
  return API.getSearchResults(params);
});
export { SearchCollection as default };